export enum Translation {
	LANGUAGE = 'language',
	RETURN = 'return',
	CREATE = 'create',
	SEARCH = 'search',
	REMOVE_SELECTED = 'remove.selected',
	LOADING = 'loading',
	SHOW = 'show',
	EDIT = 'edit',
	DELETE = 'delete',
	HELLO = 'hello',
	PROFILE = 'profile',
	SAVE = 'save',
	CANCEL = 'cancel',
	LOGO = 'logo',
	AVATAR = 'avatar',
	LOGOUT = 'logout',
	SUPPORT = 'support',
	TOTAL_QUESTIONS = 'total.questions',
	BACK_BUTTON = 'back.button',
	/* Header*/
	HEADER_MENU_CHOOSE_MEMBERSHIP = 'header.menu.membership',
	HEADER_MENU_SETTINGS = 'header.menu.settings',
	/* Sidebar */
	SIDEBAR_CLOSE = 'sidebar.close',
	SIDEBAR_OPEN = 'sidebar.open',
	SIDEBAR_MENU_MAIN = 'sidebar.menu.main',
	SIDEBAR_MENU_PLATFORM = 'sidebar.menu.platform',
	SIDEBAR_MENU_ADMIN = 'sidebar.menu.admin',
	SIDEBAR_MENU_SPECIALIZATIONS = 'sidebar.menu.specializations',
	SIDEBAR_MENU_USERS = 'sidebar.menu.users',
	SIDEBAR_MENU_EDUCATION_TITLE = 'sidebar.menu.education.title',
	SIDEBAR_MENU_EDUCATION_INTERVIEW = 'sidebar.menu.education.interview',
	SIDEBAR_MENU_QUESTIONS = 'sidebar.menu.questions',
	SIDEBAR_MENU_SKILLS = 'sidebar.menu.skills',
	SIDEBAR_MENU_COLLECTIONS = 'sidebar.menu.collections',
	SIDEBAR_MENU_COMPANIES = 'sidebar.menu.companies',

	/* Stub */
	STUB_FILTER_TITLE = 'stub.filter.text',
	STUB_FILTER_SUBMIT = 'stub.filter.submit',

	/* Modal */
	MODAL_BLOCK_TITLE = 'modal.block.title',
	MODAL_BLOCK_DESCRIPTION = 'modal.block.description',
	MODAL_DELETE_TITLE = 'modal.delete.title',
	MODAL_ACTIONS_OK = 'modal.actions.ok',
	MODAL_ACTIONS_CANCEL = 'modal.actions.cancel',

	FILE_LOADER_LINK = 'file.loader.link',
	FILE_LOADER_TEXT = 'file.loader.text',
	FILE_LOADER_TYPES_PHOTO = 'file.loader.types.photo',
	FILE_LOADER_LIMIT = 'file.loader.limit',

	SETTINGS = 'settings',
	CRUMBS_PROFILE = 'crumbs.profile',
	CRUMBS_PROFILE_EDITING = 'crumbs.profile.editing',
	CRUMBS_INTERVIEW = 'crumbs.interview',
	CRUMBS_INTERVIEW_CREATION = 'crumbs.interview.creation',
	CRUMBS_INTERVIEW_PREPARATION = 'crumbs.interview.preparation',
	CRUMBS_INTERVIEW_HISTORY = 'crumbs.interview.history',
	CRUMBS_INTERVIEW_RESULT = 'crumbs.interview.result',
	CRUMBS_INTERVIEW_STATISTIC = 'crumbs.interview.statistic',
	CRUMBS_QUESTIONS_LIST = 'crumbs.questions.list',
	CRUMBS_QUESTION_DETAIL = 'crumbs.question.detail',
	CRUMBS_COLLECTIONS_LIST = 'crumbs.collections.list',
	CRUMBS_COLLECTIONS_DETAIL = 'crumbs.collection.detail',
	CRUMBS_QUIZ = 'crumbs.quiz',

	/* Validation */
	VALIDATION_REQUIRED = 'validation.required',
	VALIDATION_EMAIL = 'validation.email',
	VALIDATION_LENGTH_MIN = 'validation.length.min',
	VALIDATION_LENGTH_MAX = 'validation.length.max',
	VALIDATION_PASSWORD_WEAK = 'validation.password.weak',
	VALIDATION_PASSWORD_SIMILAR = 'validation.password.similar',
	VALIDATION_PRIVACY = 'validation.privacy',
	VALIDATION_PARAMETER = 'validation.parameter',
	VALIDATION_FILE_SIZE = 'validation.file.size',
	VALIDATION_FILE_TYPE = 'validation.file.type',

	/* Toast */
	TOAST_TITLE_SUCCESS = 'toast.title.success',
	TOAST_TITLE_WARNING = 'toast.title.warning',
	TOAST_TITLE_ERROR = 'toast.title.error',
	TOAST_QUESTIONS_LEARNED_SUCCESS = 'toast.questions.learned.success',
	TOAST_QUESTIONS_LEARNED_FAILED = 'toast.questions.learned.failed',
	TOAST_QUESTIONS_RESET_PROGRESS_SUCCESS = 'toast.questions.reset.progress.success',
	TOAST_QUESTIONS_RESET_PROGRESS_FAILED = 'toast.questions.reset.progress.failed',
	TOAST_QUESTIONS_FAVORITE_SUCCESS = 'toast.questions.favorite.success',
	TOAST_QUESTIONS_FAVORITE_FAILED = 'toast.questions.favorite.failed',
	TOAST_QUESTIONS_RESET_FAVORITE_SUCCESS = 'toast.questions.reset.favorite.success',
	TOAST_QUESTIONS_RESET_FAVORITE_FAILED = 'toast.questions.reset.favorite.failed',
	TOAST_QUESTIONS_DELETE_SINGLE_SUCCESS = 'toast.questions.delete.single.success',
	TOAST_QUESTIONS_DELETE_SINGLE_FAILED = 'toast.questions.delete.single.failed',
	TOAST_QUESTIONS_DELETE_MULTIPLE_SUCCESS = 'toast.questions.delete.multiple.success',
	TOAST_QUESTIONS_DELETE_MULTIPLE_FAILED = 'toast.questions.delete.multiple.failed',
	TOAST_SKILLS_DELETE_SINGLE_SUCCESS = 'toast.skills.delete.single.success',
	TOAST_SKILLS_DELETE_SINGLE_FAILED = 'toast.skills.delete.single.failed',
	TOAST_SKILLS_DELETE_MULTIPLE_SUCCESS = 'toast.skills.delete.multiple.success',
	TOAST_SKILLS_DELETE_MULTIPLE_FAILED = 'toast.skills.delete.multiple.failed',
	TOAST_SPECIALIZATIONS_DELETE_SINGLE_SUCCESS = 'toast.specializations.delete.single.success',
	TOAST_SPECIALIZATIONS_DELETE_SINGLE_FAILED = 'toast.specializations.delete.single.failed',
	TOAST_SPECIALIZATIONS_DELETE_MULTIPLE_SUCCESS = 'toast.specializations.delete.multiple.success',
	TOAST_SPECIALIZATIONS_DELETE_MULTIPLE_FAILED = 'toast.specializations.delete.multiple.failed',
	TOAST_PROFILE_UPDATE_SUCCESS = 'toast.profile.update.success',
	TOAST_PROFILE_UPDATE_FAILED = 'toast.profile.update.failed',
	TOAST_PROFILE_CREATE_SUCCESS = 'toast.profile.create.success',
	TOAST_PROFILE_CREATE_FAILED = 'toast.profile.create.failed',
	TOAST_PROFILE_DELETE_SUCCESS = 'toast.profile.delete.success',
	TOAST_PROFILE_DELETE_FAILED = 'toast.profile.delete.failed',
	TOAST_PROFILE_SET_FAILED = 'toast.profile.set.failed',
	TOAST_QUESTION_CREATE_SUCCESS = 'toast.questions.create.success',
	TOAST_QUESTION_CREATE_FAILED = 'toast.questions.create.failed',
	TOAST_QUESTION_EDIT_SUCCESS = 'toast.questions.edit.success',
	TOAST_QUESTION_EDIT_FAILED = 'toast.questions.edit.failed',
	TOAST_COLLECTION_DELETE_SUCCESS = 'toast.collections.delete.single.success',
	TOAST_COLLECTION_DELETE_FAILED = 'toast.collections.delete.single.failed',
	TOAST_SKILL_CREATE_SUCCESS = 'toast.skills.create.success',
	TOAST_SKILL_CREATE_FAILED = 'toast.skills.create.failed',
	TOAST_SKILL_EDIT_SUCCESS = 'toast.skills.edit.success',
	TOAST_SKILL_EDIT_FAILED = 'toast.skills.edit.failed',
	TOAST_COLLECTION_EDIT_SUCCESS = 'toast.collections.edit.success',
	TOAST_COLLECTION_EDIT_FAILED = 'toast.collections.edit.failed',
	TOAST_SPECIALIZATION_CREATE_SUCCESS = 'toast.specializations.create.success',
	TOAST_SPECIALIZATION_CREATE_FAILED = 'toast.specializations.create.failed',
	TOAST_SPECIALIZATION_EDIT_SUCCESS = 'toast.specializations.edit.success',
	TOAST_SPECIALIZATION_EDIT_FAILED = 'toast.specializations.edit.failed',
	TOAST_AVATAR_UPDATE_SUCCESS = 'toast.avatar.update.success',
	TOAST_AVATAR_UPDATE_FAILED = 'toast.avatar.update.failed',
	TOAST_AVATAR_CREATE_SUCCESS = 'toast.avatar.create.success',
	TOAST_AVATAR_CREATE_FAILED = 'toast.avatar.create.failed',
	TOAST_AVATAR_DELETE_SUCCESS = 'toast.avatar.delete.success',
	TOAST_AVATAR_DELETE_FAILED = 'toast.avatar.delete.failed',
	TOAST_INTERVIEW_NEW_QUIZ_SUCCESS = 'toast.interview.new.quiz.success',
	TOAST_INTERVIEW_NEW_QUIZ_FAILED = 'toast.interview.new.quiz.failed',
	TOAST_INTERVIEW_FINISH_SUCCESS = 'toast.interview.finish.success',
	TOAST_INTERVIEW_FINISH_FAILED = 'toast.interview.finish.failed',
	TOAST_SETTINGS_SEND_VERIFICATION_EMAIL_FAILED = 'toast.settings.sendVerificationEmail.failed',
	TOAST_CHANGE_PASSWORD_SUCCESS = 'toast.password.change.success',
	TOAST_CHANGE_PASSWORD_FAILED = 'toast.password.change.failed',
	TOAST_CHANGE_PASSWORD_FAILED_EMAIL = 'toast.password.change.failed.email',
	TOAST_SUCCESSFULLY_CHANGE_PASSWORD = 'toast.auth.resetPassword.success',
	TOAST_ERROR_CHANGE_PASSWORD = 'toast.auth.resetPassword.failed',
	TOAST_AUTH_LOGIN_FAILED = 'toast.auth.login.failed',
	TOAST_COLLECTION_CREATE_SUCCESS = 'toast.collections.create.success',
	TOAST_COLLECTION_CREATE_FAILED = 'toast.collections.create.failed',
	TOAST_COMPANY_CREATE_SUCCESS = 'toast.companies.create.success',
	TOAST_COMPANY_CREATE_FAILED = 'toast.companies.create.failed',
	TOAST_COMPANIES_DELETE_SINGLE_SUCCESS = 'toast.companies.delete.single.success',
	TOAST_COMPANIES_DELETE_SINGLE_FAILED = 'toast.companies.delete.single.failed',
	TOAST_COMPANIES_DELETE_MULTIPLE_SUCCESS = 'toast.companies.delete.multiple.success',
	TOAST_COMPANIES_DELETE_MULTIPLE_FAILED = 'toast.companies.delete.multiple.failed',
	TOAST_COMPANY_EDIT_SUCCESS = 'toast.companies.edit.success',
	TOAST_COMPANY_EDIT_FAILED = 'toast.companies.edit.failed',
	TOAST_DELETE_ACCOUNT_SUCCESS = 'toast.user.delete.success',
	TOAST_USER_DELETE_ADMIN_SUCCESS = 'toast.user.delete.admin.success',
	TOAST_USER_DELETE_FAILED = 'toast.user.delete.failed',
	TOAST_SUBSCRIPTIONS_UNSUBSCRIBE_SUCCESS = 'toast.subscriptions.unsubscribe.success',
	TOAST_SUBSCRIPTIONS_UNSUBSCRIBE_FAILED = 'toast.subscriptions.unsubscribe.failed',
	TOAST_SUBSCRIPTIONS_SUBSCRIBE_FAILED = 'toast.subscriptions.subscribe.failed',
}
export enum Profile {
	EDIT_PAGE_TITLE = 'edit.page.title',
	TABS_PERSONAL = 'tabs.personal',
	TABS_ABOUT_ME = 'tabs.about.me',
	TABS_SKILLS = 'tabs.skills',
	TOOLTIP_CREATE_PROFILE_BUTTON_LIMIT_REACHED = 'tooltip.create.profile.button.limit.reached',
	TOOLTIP_CREATE_PROFILE_BUTTON_EMPTY_SPECIALIZATION = 'tooltip.create.profile.button.empty.specialization',
	TOOLTIP_CREATE_PROFILE_BUTTON_NOT_MEMBER = 'tooltip.create.profile.button.not.member',
	PHOTO_TITLE = 'photo.title',
	PHOTO_DESCRIPTION = 'photo.description',
	PHOTO_UPDATE = 'photo.update',
	PHOTO_DELETE = 'photo.delete',
	PHOTO_UPDATE_FULL = 'photo.update.full',
	PHOTO_DELETE_FULL = 'photo.delete.full',
	PHOTO_MODAL_TITLE = 'photo.modal.title',
	PHOTO_MODAL_DESCRIPTION = 'photo.modal.description',
	PHOTO_MODAL_SUBMIT = 'photo.modal.submit',
	PHOTO_MODAL_CLICK_SECONDARY = 'photo.modal.click.secondary',
	PHOTO_MODAL_LARGE_PREVIEW = 'photo.modal.large.preview',
	PHOTO_MODAL_SMALL_PREVIEW = 'photo.modal.small.preview',
	PHOTO_MODAL_MIN_RES = 'photo.modal.min.res',
	PHOTO_MODAL_MAX_RES = 'photo.modal.max.res',
	PERSONAL_TITLE = 'personal.title',
	PERSONAL_DESCRIPTION = 'personal.description',
	LINKS_TITLE = 'links.title',
	LINKS_DESCRIPTION = 'links.description',
	ABOUT_ME_TITLE = 'about.me.title',
	ABOUT_ME_DESCRIPTION = 'about.me.description',
	ABOUT_ME_EMPTY = 'about.me.empty',
	SKILLS_TITLE = 'skills.title',
	SKILLS_DESCRIPTION = 'skills.description',
	SKILLS_EMPTY = 'skills.empty',
	FORM_USERNAME = 'form.username',
	FORM_SPECIALIZATION = 'form.specialization',
	FORM_EMAIL = 'form.email',
	FORM_LOCATION = 'form.location',
	FORM_SKILLS = 'form.skills',
	SETTINGS_TABS_SELECT_TARIFF = 'settings.tabs.select.tariff',
	SETTINGS_TABS_CHANGE_PASSWORD = 'settings.tabs.change.password',
	SETTINGS_TABS_VERIFY_EMAIL = 'settings.tabs.verify.email',
	SETTINGS_TABS_ACCOUNT = 'settings.tabs.account',
	EMAIL_VERIFICATION_TITLE = 'email.verification.title',
	EMAIL_VERIFICATION_DESCRIPTION = 'email.verification.description',
	EMAIL_VERIFICATION_EMAIL = 'email.verification.email',
	EMAIL_VERIFICATION_SUBMIT = 'email.verification.submit',
	EMAIL_VERIFICATION_SENT_SUCCESS = 'email.verification.sent.success',
	EMAIL_VERIFICATION_VERIFY_STUB_TITLE = 'email.verification.verify.stub.title',
	EMAIL_VERIFICATION_VERIFY_STUB_DESCRIPTION = 'email.verification.verify.stub.description',
	EMAIL_VERIFICATION_VERIFY_STUB_LINK = 'email.verification.verify.stub.link',
	EMAIL_VERIFICATION_SUCCESS_VERIFY_STUB_TITLE = 'email.verification.success.verify.stub.title',
	EMAIL_VERIFICATION_SUCCESS_VERIFY_STUB_DESCRIPTION = 'email.verification.success.verify.stub.description',
	CHANGE_PASSWORD_TITLE = 'change.password.title',
	CHANGE_PASSWORD_DESCRIPTION = 'change.password.description',
	CHANGE_PASSWORD_LABEL = 'change.password.label',
	CHANGE_PASSWORD_REPEAT_LABEL = 'change.password.repeat.label',
	CHANGE_PASSWORD_PLACEHOLDER = 'change.password.placeholder',
	MANAGE_PROFILES_TITLE = 'manage.profiles.title',
	MANAGE_PROFILES_OPEN = 'manage.profiles.open',
	MANAGE_PROFILES_TOOLTIP_NOT_MEMBER = 'manage.profiles.tooltip.not.member',
	MANAGE_PROFILES_TOOLTIP_MAX_COUNT = 'manage.profiles.tooltip.max.count',
	MANAGE_PROFILES_MODAL_TITLE = 'manage.profiles.modal.title',
	MANAGE_PROFILES_MODAL_DESCRIPTION = 'manage.profiles.modal.description',
	MANAGE_PROFILES_MODAL_LABEL = 'manage.profiles.modal.label',
	MANAGE_PROFILES_MODAL_PLACEHOLDER = 'manage.profiles.modal.placeholder',
	MANAGE_PROFILES_MODAL_BUTTON = 'manage.profiles.modal.button',
}

export enum Auth {
	LOGO_TEXT = 'logo.text',
	LOGOUT = 'logout',
	BENEFITS_TITLE = 'benefits.title',
	BENEFITS_STEP_PLAN = 'benefits.step.plan',
	BENEFITS_CAREER_GROWTH = 'benefits.career.growth',
	BENEFITS_BIG_COMMUNITY = 'benefits.big.community',
	BENEFITS_MENTOR_TRAINING = 'benefits.mentor.training',
	BENEFITS_INTERNSHIP_OPPORTUNITIES = 'benefits.internship.opportunities',
	LOGIN_HELLO = 'login.hello',
	LOGIN_TITLE = 'login.title',
	LOGIN_NO_ACCOUNT = 'login.no.account',
	LOGIN_FORGOT_PASSWORD_LINK = 'login.forgot.password.link',
	LOGIN_REGISTER_LINK = 'login.register.link',
	LOGIN_SUBMIT = 'login.submit',
	REGISTRATION_TITLE = 'registration.title',
	REGISTRATION_SUBMIT = 'registration.submit',
	REGISTRATION_PRIVACY_TITLE = 'registration.privacy.title',
	REGISTRATION_PRIVACY_POLICY = 'registration.privacy.policy',
	REGISTRATION_PRIVACY_OFFER_AGREEMENT = 'registration.privacy.offer.agreement',
	REGISTRATION_PRIVACY_ADD_CONSENT = 'registration.privacy.add.consent',
	REGISTRATION_HAVE_ACCOUNT = 'registration.have.account',
	REGISTRATION_LOGIN_LINK = 'registration.login.link',
	FORM_EMAIL_LABEL = 'form.email.label',
	FORM_EMAIL_PLACEHOLDER = 'form.email.placeholder',
	FORM_PASSWORD_LABEL = 'form.password.label',
	FORM_PASSWORD_PLACEHOLDER = 'form.password.placeholder',
	FORM_PASSWORD_REPEAT_LABEL = 'form.password.repeat.label',
	FORM_PASSWORD_NEW_LABEL = 'form.password.new.label',
	FORM_PASSWORD_NEW_REPEAT_LABEL = 'form.password.new.repeat.label',
	FORM_USERNAME_LABEL = 'form.username.label',
	FORM_USERNAME_PLACEHOLDER = 'form.username.placeholder',
	FORGOT_PASSWORD_TITLE = 'forgot.password.title',
	FORGOT_PASSWORD_SUBTITLE = 'forgot.password.subtitle',
	FORGOT_PASSWORD_SUBMIT = 'forgot.password.submit',
	FORGOT_PASSWORD_MODAL_TITLE = 'forgot.password.modal.title',
	FORGOT_PASSWORD_MODAL_SUBTITLE = 'forgot.password.modal.subtitle',
	FORGOT_PASSWORD_MODAL_SUBMIT = 'forgot.password.modal.submit',
	PASSWORD_RECOVERY_TITLE = 'password.recovery.title',
	PASSWORD_RECOVERY_SUBTITLE = 'password.recovery.subtitle',
	PASSWORD_RECOVERY_SUBMIT = 'passwordRecovery.submit',
}

export enum Specializations {
	TITLE_MAIN = 'title.main',
	TITLE_FULL = 'title.full',
	TITLE_SHORT = 'title.short',
	TITLE_LABEL = 'title.label',
	DESCRIPTION_FULL = 'description.full',
	DESCRIPTION_SHORT = 'description.short',
	DESCRIPTION_LABEL = 'description.label',
	DESCRIPTION_PLACEHOLDER = 'description.placeholder',
	EMPTY = 'empty',
	IMAGE_SRC = 'image.src',
	IMAGE_ALT = 'image.alt',
	CREATE_PAGE_TITLE = 'create.page.title',
	EDIT_PAGE_TITLE = 'edit.page.title',
	STUB_EMPTY_TITLE = 'stub.empty.title',
	STUB_EMPTY_DESCRIPTION = 'stub.empty.description',
	SELECT_CHOOSE = 'select.choose',
	SELECT_EMPTY = 'select.empty',
	SELECT_SELECTED = 'select.selected',
}

export enum InterviewQuiz {
	TITLE = 'title',
	PREVIEW_TITLE = 'preview.title',
	CONTINUE_QUIZ = 'continue.quiz',
	PROGRESS_BAR_TITLE = 'progress.bar.title',
	START_QUIZ_TITLE = 'start.quiz.title',
	START_QUIZ_DESCRIPTION = 'start.quiz.description',
	START_QUIZ_LINK = 'start.quiz.link',
	INTERRUPT_QUIZ_TITLE = 'interrupt.quiz.title',
	INTERRUPT_QUIZ_DESCRIPTION = 'interrupt.quiz.description',
	INTERRUPT_QUIZ_YES = 'interrupt.quiz.yes',
	INTERRUPT_QUIZ_NO = 'interrupt.quiz.no',
	COMPLETE = 'complete',
	NEXT = 'next',
	CHECK = 'check.quiz',
	A11Y_NEXT = 'a11y.next',
	A11Y_PREV = 'a11y.prev',
	ANSWER_SHOW = 'answer.show',
	ANSWER_HIDE = 'answer.hide',
	ANSWER_DO_NOT_KNOW = 'answer.do.not.know',
	ANSWER_KNOW = 'answer.know',
	MODAL_QUIZ_TITLE = 'modal.quiz.title',
	MODAL_QUIZ_DESCRIPTION = 'modal.quiz.description',
	MODAL_QUIZ_ACTIONS_OK = 'modal.quiz.ok',
	MODAL_QUIZ_ACTIONS_CANCEL = 'modal.quiz.cancel',
}

export enum InterviewQuizCreate {
	TITLE = 'title',
	CREATE_BUTTON = 'create.button',
	MODE_REPEAT = 'mode.repeat',
	MODE_NEW = 'mode.new',
	MODE_RANDOM = 'mode.random',
	MODE_SELECT = 'mode.select',
	MODE_SELECT_TOOLTIP_UNAUTHORIZED = 'mode.select.tooltip.unauthorized',
}

export enum InterviewQuizResult {
	TITLE_QUESTIONS_ANSWERS = 'title.questions.answers',
	TITLE_STAT = 'title.stat',
	TITLE_QUESTIONS_LIST = 'title.questions.list',
	PASSED_QUESTION = 'passed.question',
	TIME = 'time',
	DATE = 'date',
	DURATION = 'duration',
	CLONE_BUTTON = 'clone.button',
	JOIN_COMMUNITY_TITLE = 'join.community.title',
	JOIN_COMMUNITY_DESCRIPTION = 'join.community.description',
	INTERVIEW_SIMULATOR = 'join.community.interview.simulator',
	MEMORY_MODE = 'join.community.memory.mode',
	STATS_HISTORY = 'join.community.stats.history',
	FULL_ACCESS = 'join.community.full.access',
	BECOME_MEMBER = 'join.community.become.member',
}

export enum InterviewStatistics {
	PROGRESS_TITLE = 'progress.title',
	PASSED = 'passed',
	SOON = 'soon',
	LINK = 'link',
	QUESTION_STATS_TITLE = 'question.stats.title',
	QUESTION_STATS_TITLE_SHORT = 'question.stats.title.short',
	QUESTION_STATS_ALL = 'question.stats.all',
	QUESTION_STATS_NEW = 'question.stats.new',
	QUESTION_STATS_IN_PROCESS = 'question.stats.in.process',
	QUESTION_STATS_LEARNED = 'question.stats.learned',
	ATTEMPT_STATS_TITLE = 'attempt.stats.title',
	ATTEMPT_STATS_BEST = 'attempt.stats.best.default',
	ATTEMPT_STATS_WORST = 'attempt.stats.worst.default',
	ATTEMPT_STATS_AVG = 'attempt.stats.avg.default',
	ATTEMPT_STATS_BEST_MOBILE = 'attempt.stats.best.mobile',
	ATTEMPT_STATS_WORST_MOBILE = 'attempt.stats.worst.mobile',
	ATTEMPT_STATS_AVG_MOBILE = 'attempt.stats.avg.mobile',
}

export enum Questions {
	COUNT = 'count',
	COUNT_TOOLTIP_UNAUTHORIZED = 'count.tooltip.unauthorized',
	PREVIEW_TITLE = 'preview.title',
	PREVIEW_LINK = 'preview.link',
	PREVIEW_EMPTY_SPECIALIZATION = 'preview.empty.specialization',
	PREVIEW_EMPTY_COLLECTION = 'preview.empty.collection',
	PREVIEW_LOCKED_COLLECTION = 'preview.locked.collection',
	TITLE_SHORT = 'title.short',
	TITLE_LABEL = 'title.label',
	TITLE_PLACEHOLDER = 'title.placeholder',
	DESCRIPTION_TITLE = 'description.title',
	DESCRIPTION_LABEL = 'description.label',
	DESCRIPTION_PLACEHOLDER = 'description.placeholder',
	SEARCH_PLACEHOLDER = 'search.placeholder',
	CATEGORIES_TITLE = 'categories.title',
	CATEGORIES_SHOW_ALL = 'categories.show.all',
	CATEGORIES_HIDE = 'categories.hide',
	PROGRESS_TITLE = 'progress.title',
	PROGRESS_DESCRIPTION = 'progress.description',
	COMPLEXITY_TITLE = 'complexity.title',
	COMPLEXITY_TITLE_SHORT = 'complexity.title.short',
	COMPLEXITY_LABEL = 'complexity.label',
	COMPLEXITY_TOOLTIP_UNAUTHORIZED = 'complexity.tooltip.unauthorized',
	RATE_TITLE = 'rate.title',
	RATE_TITLE_SHORT = 'rate.title.short',
	RATE_LABEL = 'rate.label',
	SORT_FIELD = 'sort.field',
	SORT_TITLE = 'sort.title',
	SORT_ASCENDING = 'sort.ascending',
	SORT_DESCENDING = 'sort.descending',
	STATUS_TITLE = 'status.title',
	STATUS_UNLEARNED = 'status.unlearned',
	STATUS_LEARNED = 'status.learned',
	STATUS_ALL = 'status.all',
	STATUS_FAVORITE = 'status.favorite',
	STATUS_LABEL = 'status.label',
	STATUS_PUBLIC = 'status.public',
	STATUS_DRAFT = 'status.draft',
	SKILLS_TITLE = 'skills.title',
	SKILLS_LABEL = 'skills.label',
	LONG_ANSWER_TITLE = 'long.answer.title',
	LONG_ANSWER_LABEL = 'long.answer.label',
	LONG_ANSWER_PLACEHOLDER = 'long.answer.placeholder',

	SHORT_ANSWER_TITLE = 'short.answer.title',
	SHORT_ANSWER_LABEL = 'short.answer.label',
	SHORT_ANSWER_PLACEHOLDER = 'short.answer.placeholder',
	SPECIALIZATION_TITLE = 'specialization.title',
	SPECIALIZATION_LABEL = 'specialization.label',
	KEYWORDS_TITLE = 'keywords.title',
	KEYWORDS_LABEL = 'keywords.label',
	AUTHOR = 'author',
	IMAGE_ALT = 'image.alt',
	MORE = 'more',
	LEARN = 'learn',
	REPEAT = 'repeat',
	FAVORITE = 'favorite',
	TOOLTIP_LEARN = 'tooltip.learn',
	TOOLTIP_REPEAT = 'tooltip.repeat',
	TOOLTIP_MEMBERS_ONLY = 'tooltip.members.only',
	TOOLTIP_NOT_CONFIRMED = 'tooltip.not.confirmed',
	TOOLTIP_FAVORITE_ADD = 'tooltip.favorite.add',
	TOOLTIP_FAVORITE_DELETE = 'tooltip.favorite.delete',

	ADDITIONAL_INFO_LEVEL = 'level',
	ADDITIONAL_INFO_SKILLS = 'skillsAdditional',
	ADDITIONAL_INFO_KEYWORDS = 'keywordsAdditional',
	ADDITIONAL_INFO_ARIA_LABEL = 'additional.aria.label',

	COMMUNITY_JOIN = 'community.join',
}

export enum InterviewHistory {
	TITLE = 'title',
	QUIZ_TITLE = 'quiz.title',
	START_DATE = 'start.date',
	TOTAL_QUESTIONS = 'total.questions',
	RESULT = 'result',
	LINK = 'link',
	EMPTY = 'empty',
	UNVERIFIED = 'unverified',
	NO_PREMIUM = 'no.premium',
	PREV_MONTH = 'prev.month',
	NEXT_MONTH = 'next.month',
}

export enum Main {
	FILL_PROFILE_TITLE = 'fill.profile.title',
	FILL_PROFILE_DESCRIPTION = 'fill.profile.description',
	FILL_PROFILE_LINK = 'fill.profile.link',
	SUBSCRIBE_MEDIA_TITLE = 'subscribe.media.title',
	SUBSCRIBE_MEDIA_DESCRIPTION = 'subscribe.media.description',
	SUBSCRIBE_MEDIA_YEAHUB_TITLE = 'subscribe.media.yeahub.title',
	SUBSCRIBE_MEDIA_YEAHUB_DESCRIPTION = 'subscribe.media.yeahub.description',
	SUBSCRIBE_MEDIA_YEAHUB_COMMUNITY_TITLE = 'subscribe.media.community.yeahub.title',
	SUBSCRIBE_MEDIA_YEAHUB_COMMUNITY_DESCRIPTION = 'subscribe.media.community.yeahub.description',
}

export enum Skills {
	TITLE_FULL = 'title.full',
	TITLE_SHORT = 'title.short',
	TITLE_LABEL = 'title.label',
	DESCRIPTION_FULL = 'description.full',
	DESCRIPTION_SHORT = 'description.short',
	DESCRIPTION_LABEL = 'description.label',
	DESCRIPTION_PLACEHOLDER = 'description.placeholder',
	ICON_TITLE = 'icon.title',
	ICON_LABEL = 'icon.label',
	SELECT_CHOOSE = 'select.choose',
	SELECT_EMPTY = 'select.empty',
	SELECT_SELECTED = 'select.selected',
	EMPTY = 'empty',
	IMAGE_SRC = 'image.src',
	CREATE_PAGE_TITLE = 'create.page.title',
	EDIT_PAGE_TITLE = 'edit.page.title',
}

export enum User {
	NAME = 'name',
	ROLE = 'role',
	EMAIL = 'email',
	GUEST = 'roles.guest',
	CANDIDATE = 'roles.candidate',
	CANDIDATE_FREE = 'roles.candidate.free',
	CANDIDATE_PREMIUM = 'roles.candidate.premium',
	HR = 'roles.HR',
	AUTHOR = 'roles.author',
	ADMIN = 'roles.admin',
	MEMBER = 'roles.member',
	USER_NAME = 'user.name',
	USERNAME = 'username',
	AVATAR = 'avatar',
	SELECT_ROLE_TITLE = 'select.role.title',
	SELECT_ROLE_LABEL = 'select.role.label',
	CONFIRM_EMAIL_TITLE = 'confirm.email.title',
	CONFIRM_EMAIL_LABEL = 'confirm.email.label',
	CONFIRM_EMAIL_CONFIRM = 'confirm.email.confirm',
	CONFIRM_EMAIL_UNCONFIRM = 'confirm.email.unconfirm',
	ADDRESS = 'address',
	BIRTH_DATE = 'birth.date',
	REGISTRATION_DATE = 'registration.date',
	SELECT_CHOOSE = 'select.shoose',
	FILTER_ROLE = 'filter.role',
	FILTER_EMAIL = 'filter.email',
	SUBSCRIPTION_FREE = 'subscription.free',
	SUBSCRIPTION_PREMIUM = 'subscription.premium',
	EDIT_SUCCESS = 'edit.success',
	EDIT_ERROR = 'edit.error',
	DELETE_TITLE = 'delete.title',
	DELETE_ADMIN_TITLE = 'delete.admin.title',
	DELETE_DESCRIPTION_MAIN = 'delete.description.main',
	DELETE_DESCRIPTION_MODAL = 'delete.description.modal',
	DELETE_ADMIN_DESCRIPTION_MODAL = 'delete.admin.description.modal',
	DELETE_BUTTON = 'delete.button',
	DELETE_ADMIN_BUTTON = 'delete.admin.button',
	DELETE_LABEL = 'delete.label',
	DELETE_PLACEHOLDER = 'delete.placeholder',
}

export enum Collections {
	TITLE_FULL = 'title.full',
	TITLE_SHORT = 'title.short',
	TITLE_LABEL = 'title.label',
	DESCRIPTION_FULL = 'description.full',
	DESCRIPTION_SHORT = 'description.short',
	DESCRIPTION_LABEL = 'description.label',
	DESCRIPTION_PLACEHOLDER = 'description.placeholder',
	ICON_TITLE = 'icon.title',
	ICON_TITLE_SHORT = 'icon.title-short',
	ICON_LABEL = 'icon.label',
	TARIFF_CHOOSE = 'tariff.chooseCollections',
	TARIFF_LABEL = 'tariff.label',
	TARIFF_PAID = 'tariff.paid',
	TARIFF_FREE = 'tariff.free',
	SELECT_SELECTED = 'select.selected',
	EMPTY = 'empty',
	IMAGE_SRC = 'image.src',
	CREATE_PAGE_TITLE = 'create.page.title',
	EDIT_PAGE_TITLE = 'edit.page.title',
	ADDITIONAL_INFO_ACCESS = 'access',
	ADDITIONAL_INFO_ARIA_LABEL = 'additional.aria.label',
	QUESTIONS_SHORT = 'questions.short',
	QUESTIONS_LABEL = 'questions.label',
	QUESTIONS_SELECTED = 'questions.selected',
	QUESTIONS_ADDITIONAL_INFO = 'numberOfQuestions',
	QUESTIONS_COUNT = 'questions.length.min',
	// QUESTIONS_ADD: 'collections.questions.add',
	// QUESTIONS_LABEL: 'collections.questions.label',
	IMAGE_ALT = 'image.alt',
	SEARCH_PLACEHOLDER = 'search.placeholder',
	COLLECTIONS_TITLE = 'collections.title',
	COLLECTIONS_DETAIL = 'collections.detail',
	COLLECTIONS_TRAIN = 'collections.train',
	SPECIALIZATIONS_SHOW_ALL = 'specializations.show.all',
	SPECIALIZATIONS_HIDE = 'specializations.hide',
	SPECIALIZATION_TITLE = 'specialization.title',
	SPECIALIZATION_LABEL = 'specialization.label',
	KEYWORDS_TITLE = 'keywords.title',
	KEYWORDS_LABEL = 'keywords.label',
	TAGS_TITLE = 'tags.title',
	TOOLTIP_TITLE = 'tooltip.title',
	TOOLTIP_ARIA_LABEL = 'tooltip.aria.label',
	COMPANY_TITLE = 'company.title',
	COMPANY_LABEL = 'company.label',

	WARNING_INTRO = 'warning.intro',
	WARNING_DISCLAIMER = 'warning.disclaimer',
}

export enum Marketplace {
	HEADER_TITLE = 'header.title',
	LINK_LABEL = 'add.resource.link.label',
}

export enum Companies {
	TITLE_FULL = 'title.full',
	TITLE_SHORT = 'title.short',
	TITLE_LABEL = 'title.label',
	ICON_TITLE = 'icon.title',
	ICON_LABEL = 'icon.label',
	CREATE_PAGE_TITLE = 'create.page.title',
	EDIT_PAGE_TITLE = 'edit.page.title',
	SELECT_CHOOSE = 'select.choose',
	SELECT_EMPTY = 'select.empty',
	SELECT_SELECTED = 'select.selected',
}

export enum Landing {
	LOGIN = 'header.actions.login',
	REGISTER = 'header.actions.register',
	QUESTIONS_TITLE = 'questions.title',
	QUESTIONS_DESCRIPTION = 'questions.description',
	QUESTIONS_FIRST = 'questions.first',
	QUESTIONS_SECOND_TITLE = 'questions.second.title',
	QUESTIONS_SECOND_ANSWER = 'questions.second.answer',
	QUESTIONS_THIRD = 'questions.third',
	QUESTIONS_FOURTH = 'questions.fourth',
	MAIN_TITLE_MOBILE = 'main.title.mobile',
	MAIN_TITLE_TABLET = 'main.title.tablet',
	MAIN_TITLE_DESKTOP = 'main.title.desktop',
	MAIN_SUBTITLE = 'main.subtitle',
	MAIN_LINK = 'main.link',
	MAIN_BADGE = 'main.badge',
	MAIN_ADVANTAGES_FIRST_TITLE = 'main.advantages.first.title',
	MAIN_ADVANTAGES_FIRST_DESCRIPTION = 'main.advantages.first.description',
	MAIN_ADVANTAGES_SECOND_TITLE = 'main.advantages.second.title',
	MAIN_ADVANTAGES_SECOND_DESCRIPTION = 'main.advantages.second.description',
	MAIN_ADVANTAGES_THIRD_TITLE = 'main.advantages.third.title',
	MAIN_ADVANTAGES_THIRD_DESCRIPTION = 'main.advantages.third.description',
	MAIN_PROGRESS_TITLE = 'main.progress.title',
	MAIN_PROGRESS_DESCRIPTION = 'main.progress.description',
	TRAINING_TITLE = 'training.title',
	TRAINING_SUBTITLE = 'training.subtitle',
	TRAINING_SUBTITLE_TABLET = 'training.subtitle.tablet',
	TRAINING_ADVANTAGES_FIRST = 'training.advantages.first',
	TRAINING_ADVANTAGES_SECOND = 'training.advantages.second',
	TRAINING_LINK = 'training.link',
	TRAINING_INTERVIEW_TITLE = 'training_interview.title',
	TRAINING_INTERVIEW_SUBTITLE = 'training_interview.subtitle',
	TRAINING_INTERVIEW_SUBTITLE_TABLET = 'training_interview.subtitle.tablet',
	TRAINING_INTERVIEW_ADVANTAGES_FIRST = 'training_interview.advantages.first',
	TRAINING_INTERVIEW_ADVANTAGES_SECOND = 'training_interview.advantages.second',
	TRAINING_INTERVIEW_LINK = 'training_interview.link',
	READY_INTERVIEW_TITLE = 'ready.interview.title',
	READY_INTERVIEW_SUBTITLE = 'ready.interview.subtitle',
	READY_INTERVIEW_ADVANTAGES_FIRST = 'ready.interview.advantages.first',
	READY_INTERVIEW_ADVANTAGES_SECOND = 'ready.interview.advantages.second',
	INTERVIEW_TITLE = 'interview.title',
	INTERVIEW_SUBTITLE = 'interview.subtitle',
	INTERVIEW_ADVANTAGES_FIRST = 'interview.advantages.first',
	INTERVIEW_ADVANTAGES_SECOND = 'interview.advantages.second',
	PROGRESS_TITLE = 'progress.title',
	PROGRESS_SUBTITLE = 'progress.subtitle',
	PROGRESS_ADVANTAGES_FIRST = 'progress.advantages.first',
	PROGRESS_ADVANTAGES_SECOND = 'progress.advantages.second',
	SPECIALIZATION_TITLE = 'specialization.title',
	SPECIALIZATION_DESCRIPTION = 'specialization.description',
	SKILLS_TITLE = 'skills.title',
	SKILLS_DESCRIPTION = 'skills.description',
	FILTERS_TITLE = 'filters.title',
	FILTERS_DESCRIPTION = 'filters.description',
	COOKIES_TEXT = 'cookies.text',
	COOKIES_LINK = 'cookies.link',
	COOKIES_AGREE = 'cookies.agree.button',
	FOOTER_SLOGAN = 'footer.slogan',
	FOOTER_ABOUT = 'footer.about',
	FOOTER_DOCS = 'footer.docs',

	// для нового лендинга ниже
	BANNER_STICKER_SKILL = 'banner.sticker.skill',
	BANNER_STICKER_CANDIDATE = 'banner.sticker.candidate',
	BANNER_TITLE = 'banner.title',
	BANNER_DESCRIPTION = 'banner.description',
	BANNER_BUTTON = 'banner.button',
	BANNER_IMG_HOMEPAGE = 'banner.img.homepage',
	BANNER_IMG_STATISTICS = 'banner.img.statistics',
	BANNER_IMG_COMPANY = 'banner.img.company',
	BANNER_IMG_PROGRESS = 'banner.img.progress',
	COLLECTION_CARD_SBER = 'collections.cards.sber',
	COLLECTION_CARD_TBANK = 'collections.cards.tbank',
	COLLECTION_CARD_VK = 'collections.cards.vk',
	COLLECTION_TITLE = 'collections.title',
	COLLECTION_SUBTITLE = 'collections.subtitle',
	COLLECTION_ADDITIONAL_FIRST = 'collections.additional.first',
	COLLECTION_ADDITIONAL_SECOND = 'collections.additional.second',
	COLLECTION_ADDITIONAL_THIRD = 'collections.additional.third',
	COLLECTION_LINK = 'collections.link',
	COLLECTION_EXPAND = 'collections.expand',
	COLLECTION_STAR = 'collections.star',
	HEADER_NAV_QUESTIONS_LIST = 'header.nav.questions.list',
	HEADER_NAV_PUBLIC_QUIZ = 'header.nav.public.quiz',
	HEADER_NAV_PUBLIC_COLLECTIONS = 'header.nav.public.collections',
	HEADER_NAV_POPOVER_TITLE = 'header.nav.popover.title',
	HEADER_NAV_ARIA_LABEL = 'header.nav.aria.label',
	HEADER_AUTH_ICONBUTTON_ARIA_LABEL = 'header.auth.iconbutton.aria.label',
	FOOTER_LINKS_LINK_ARIA_LABEL = 'footer.links.link.aria.label',
	FOOTER_TITLE = 'footer.title',
	FOOTER_DESCRIPTION = 'footer.description',
	APP_LOGO_ARIA_LABEL = 'app.logo.aria.label',
	SPECIALIZATION_NEW_TITLE = 'specialization.title_new',
	SPECIALIZATION_BUTTON = 'specialization.button',
	SPECIALIZATION_CARD_DESCRIPTION_FRONTEND = 'specialization.card.description.frontend',
	SPECIALIZATION_CARD_DESCRIPTION_BACKEND = 'specialization.card.description.backend',
	SPECIALIZATION_CARD_DESCRIPTION_DATA = 'specialization.card.description.data',
	SPECIALIZATION_CARD_DESCRIPTION_MACHINE = 'specialization.card.description.machine',
	SPECIALIZATION_CARD_DESCRIPTION_TESTING = 'specialization.card.description.testing',
	SPECIALIZATION_CARD_DESCRIPTION_IOS = 'specialization.card.description.ios',
	SPECIALIZATION_CARD_DESCRIPTION_ANDROID = 'specialization.card.description.android',
	SPECIALIZATION_CARD_DESCRIPTION_GAME = 'specialization.card.description.game',
	SPECIALIZATION_CARD_IMG_FRONTEND = 'specialization.card.img.frontend',
	SPECIALIZATION_CARD_IMG_BACKEND = 'specialization.card.img.backend',
	SPECIALIZATION_CARD_IMG_DATA = 'specialization.card.img.data',
	SPECIALIZATION_CARD_IMG_MACHINE = 'specialization.card.img.machine',
	SPECIALIZATION_CARD_IMG_TESTING = 'specialization.card.img.testing',
	SPECIALIZATION_CARD_IMG_IOS = 'specialization.card.img.ios',
	SPECIALIZATION_CARD_IMG_ANDROID = 'specialization.card.img.android',
	SPECIALIZATION_CARD_IMG_GAME = 'specialization.card.img.game',
	SPECIALIZATION_CARD_BUTTON = 'specialization.card.button',
	HISTORY_TITLE = 'history.title',
	HISTORY_SUBTITLE = 'history.subtitle',
	HISTORY_SLIDES_FIRST = 'history.slides.first',
	HISTORY_SLIDES_SECOND = 'history.slides.second',
	HISTORY_SLIDES_THIRD = 'history.slides.third',
	HISTORY_IMG_STATISTICS = 'history.img.statistics',
	HISTORY_IMG_PROGRESS = 'history.img.progress',
	HISTORY_IMG_DESCRIPTION = 'history.img.description',
}

export enum Subscription {
	SUBSCRIBE_ACTION = 'subscribeAction',
	UNSUBSCRIBE_MODAL_TITLE = 'unsubscribe.modal.title',
	UNSUBSCRIBE_MODAL_BUTTON_YES = 'unsubscribe.modal.button.yes',
	UNSUBSCRIBE_MODAL_BUTTON_NO = 'unsubscribe.modal.button.no',
	UNSUBSCRIBE_MODAL_DESCRIPTION = 'unsubscribe.modal.description',
	CHANGE_TARIFF_PLAN = 'changeTariffPlan',
	CANCEL_SUBSCRIPTION = 'cancelSubscription',
	PAY_HISTORY = 'payHistory',
	TARIFF_FREE = 'tariff.free',
	TARIFF_BASE = 'tariff.base',
	TARIFF_PREMIUM = 'tariff.premium',
	DAYS_LEFT = 'daysLeft',
	SUBSCRIPTION_GREETING = 'greeting',
	SUBSCRIPTION_RENEWAL = 'renewal',
	SUBSCRIPTION_CANCELED = 'canceled',
	SUBSCRIPTION_ACCESS_WARNING = 'accessWarning',
	SUBSCRIPTION_FAQ_TITLE = 'faq.title',
	SUBSCRIPTION_FAQ_FIRST_QUESTION = 'faq.first.question',
	SUBSCRIPTION_FAQ_FIRST_ANSWER = 'faq.first.answer',
	SUBSCRIPTION_FAQ_SECOND_QUESTION = 'faq.second.question',
	SUBSCRIPTION_FAQ_SECOND_ANSWER = 'faq.second.answer',
	SUBSCRIPTION_FAQ_THIRD_QUESTION = 'faq.third.question',
	SUBSCRIPTION_FAQ_THIRD_ANSWER = 'faq.third.answer',
	SUBSCRIPTION_FAQ_FOURTH_QUESTION = 'faq.fourth.question',
	SUBSCRIPTION_FAQ_FOURTH_ANSWER = 'faq.fourth.answer',
}

export enum SubscriptionCard {
	SUBSCRIPTION_TITLE = 'subscription.title',
	SUBSCRIPTION_DESCRIPTION = 'subscription.description',
	SUBSCRIPTION_CARD_PRICE = 'subscription.price',
	SUBSCRIPTION_CARD_ADVANTAGES_FIRST = 'subscription.advantages.first',
	SUBSCRIPTION_CARD_ADVANTAGES_SECOND = 'subscription.advantages.second',
	SUBSCRIPTION_CARD_ADVANTAGES_THIRD = 'subscription.advantages.third',
	SUBSCRIPTION_CARD_ADVANTAGES_FOURTH_FREE = 'subscription.advantages.fourth.free',
	SUBSCRIPTION_CARD_ADVANTAGES_FOURTH_PAID = 'subscription.advantages.fourth.paid',
	SUBSCRIPTION_CARD_FREE_TITLE = 'subscription.free.title',
	SUBSCRIPTION_CARD_FREE_DESCRIPTION = 'subscription.free.description',
	SUBSCRIPTION_CARD_PREMIUM_TITLE = 'subscription.premium.title',
	SUBSCRIPTION_CARD_PREMIUM_DESCRIPTION = 'subscription.premium.description',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_TITLE = 'subscription.premium.tooltip.title',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_TITLE = 'subscription.premium.tooltip.list.title',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_FIRST = 'subscription.premium.tooltip.list.first',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_SECOND = 'subscription.premium.tooltip.list.second',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_THIRD = 'subscription.premium.tooltip.list.third',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_FOURTH = 'subscription.premium.tooltip.list.fourth',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_FIFTH = 'subscription.premium.tooltip.list.fifth',
	SUBSCRIPTION_CARD_PREMIUM_TOOLTIP_LIST_THANKS = 'subscription.premium.tooltip.list.thanks',
	SUBSCRIPTION_CARD_PRIVACY_TITLE = 'subscription.privacy.title',
	SUBSCRIPTION_CARD_PRIVACY_OFFER_AGREEMENT = 'subscription.privacy.offer.agreement',
	SUBSCRIPTION_CARD_PRIVACY_CONSENT = 'subscription.privacy.consent',
}

export enum Docs {
	LINK = 'link',
	DOC1 = 'doc1',
	DOC2 = 'doc2',
	DOC3 = 'doc3',
	DOC4 = 'doc4',
	DOC5 = 'doc5',
	DOC6 = 'doc6',
}

export enum TextEditor {
	BOLD = 'editor.bold',
	ITALIC = 'editor.italic',
	UNDERLINE = 'editor.underline',
	STRIKE = 'editor.strike',
	CODE_INLINE = 'editor.code.inline',
	ALIGN_LEFT = 'editor.align.left',
	ALIGN_CENTER = 'editor.align.center',
	ALIGN_RIGHT = 'editor.align.right',
	HEADINGS = 'editor.headings',
	BLOCKQUOTE = 'editor.blockquote',
	CODE_BLOCK = 'editor.code.block',
	UNDO = 'editor.undo',
	REDO = 'editor.redo',
	BULLET_LIST = 'editor.bullet.list',
	ORDERED_LIST = 'editor.ordered.list',
}

export enum Guru {
	BANNER_TITLE = 'banner.title',
	BANNER_DESCRIPTION = 'banner.description',
}
export enum Media {
	MEDIA_LINK_START = 'label.start',
	MEDIA_LINK_END = 'label.end',
}
export enum Marketplace {
	SEARCH_PLACEHOLDER = 'search.placeholder',
	SHOW_ALL = 'show.all',
	HIDE = 'hide',
	KEYWORDS_TITLE = 'keywords.title',
	RESOURCES_TITLE = 'resources.title',
	RESOURCES_REPOSITORY = 'resources.repository',
	RESOURCES_VIDEO = 'resources.video',
	RESOURCES_ARTICLE = 'resources.article',
	RESOURCES_COURSE = 'resources.course',
	STATUS_ALL = 'status.all',
	STATUS_TITLE = 'status.title',
}
